// App Imports
import params from '../../../setup/config/params'
import List from '../List'
import Update from '../Update'

// Pages routes
const routes = {
  vendorList: {
    path: (page = ':page') => `/vendors/${page}`,
    activePath: '/vendor',
    component: List,
    auth: true,
    role: params.user.roles.admin.key,
    module: "utilities",
    subModule: "storeSettings",
    action: "canView",
  },

  vendorDetail: {
    path: (vendorId = ':vendorId') => `/vendor/detail/${vendorId}`,
    component: List,
    auth: true,
    role: params.user.roles.admin.key,
    module: "utilities",
    subModule: "storeSettings",
    action: "canView",
  },

  vendorUpdate: {
    path: (vendorId = ':vendorId') => `/vendor/update/${vendorId}`,
    component: Update,
    auth: true,
    role: params.user.roles.admin.key,
    module: "utilities",
    subModule: "storeSettings",
    action: "canView",
  },
};

export default routes;
